module.exports = __webpack_public_path__ + "img/backIcon.8b74836e.svg";